import React from 'react';
import { homeObjFour } from './Data';
import { InfoSection } from '../../components';
import Pricing from '../../components/Pricing/Pricing';

const ThePricing = () => {
    return (
        <div>
            <Pricing />
            <InfoSection {...homeObjFour} />
        </div>
    )
}

export default ThePricing;